export default {
  namespased: true,
  state: {
    // wyświetla modal jeśli active jest true
    active: false,
    title: '',
    content: '',
    klass: '',
    buttonMessage: 'OK'
  },
  getters: {
  },
  actions: {
  },
  mutations: {
    setNotice(state, {message, klass, btnMessage} ){
      state.active = true;
      state.content = message;
      state.klass = klass || '' ;
      state.buttonMessage = btnMessage || 'OK';
    },

    closeNotice(state){
      state.active = false;
      state.content = '';
      state.klass = '';
      state.buttonMessage = 'OK';
    }
  }
}